import { BrowserRouter, Route, Routes } from "react-router-dom";
import { NotFound } from "../modules/404";
import { useMe } from "../modules/users/hooks/useMe";

import { DashboardLayout } from "../layouts/dashboard.layout";
import { ProtectedRoute } from "./protected-route";
import { Loading } from "../components";

import { Dashboard } from "../modules/dashboard";
import { CustomersRouter } from "../modules/customers/customers.router";
import { UsersRouter } from "../modules/users/users.router";
import { CategoriesRouter } from "../modules/categories/categories.router";
import { ContactsRouter } from "../modules/contacts/contacts.router";
import { ProspectionsRouter } from "../modules/prospections/prospections.router";
import { MailboxesRouter } from "../modules/mailboxes/mailboxes.router";
import { MailMessagesRouter } from "../modules/mail-messages/mail-messages.router";
import { CmsRouter } from "../modules/cms/cms.router";
import { ReportsRouter } from "../modules/reports/reports.router";
import { ArticlesRouter } from "../modules/articles/articles.router";
import { TutoRouter } from "../modules/tuto/tuto.router";
import { ThemesRouter } from "../modules/themes/themes.router";
import { PromptFragmentsRouter } from "../modules/prompt-fragments/prompt-fragments.router";
import { CreatedSitesRouter } from "../modules/created-sites/created-sites.router";
import { CustomerTasksRouter } from "../modules/customer-tasks/customer-tasks.router";
import { SalesArgumentsRouter } from "../modules/sales-arguments/sales-arguments.router";

import { AdminRouter } from "./admin-router";
import { ClientRouter } from "./client-router";

import { UserRole } from "../__generated__/globalTypes";

export const LoggedInRouter = () => {
  const { data, loading, error } = useMe();

  if (!data || loading || error) {
    return <Loading />;
  }

  if (data?.me?.role === UserRole.Admin) {
    return <AdminRouter />;
  }
  if (data?.me?.role === UserRole.Client) {
    return <ClientRouter />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DashboardLayout />}>
          <Route element={<ProtectedRoute roles={["Any"]} />}>
            <Route path="/" element={<Dashboard />} />
          </Route>
          {CustomersRouter}
          {UsersRouter}
          {CategoriesRouter}
          {ContactsRouter}
          {ProspectionsRouter}
          {MailboxesRouter}
          {MailMessagesRouter}
          {CmsRouter}
          {ReportsRouter}
          {ArticlesRouter}
          {TutoRouter}
          {ThemesRouter}
          {PromptFragmentsRouter}
          {CreatedSitesRouter}
          {CustomerTasksRouter}
          {SalesArgumentsRouter}
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
